const TermsOfUse = () => {
    return (
      <main
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "40px 20px",
          fontFamily: "Arial, sans-serif",
          lineHeight: 1.6,
          color: "#ffffff",
        }}
      >
        <h1>Terms of Use</h1>
  
        <p>
          <strong>Last Updated:</strong> 5/7/2026
        </p>
  
        <p>
          By accessing or using this website, you agree to be bound by these Terms
          of Use. If you do not agree to these terms, do not use this website.
        </p>
  
        <h2>Use of Website</h2>
        <p>
          This website is provided for informational and business purposes only.
          You agree to use this website lawfully and in a manner that does not
          interfere with the operation, security, or availability of the website.
        </p>
  
        <h2>No Guarantee of Results</h2>
        <p>
          Submission of a form, inquiry, or request through this website does not
          guarantee acceptance, approval, service availability, business outcomes,
          financial results, or any specific response timeframe.
        </p>
  
        <h2>User-Submitted Information</h2>
        <p>
          You are responsible for the accuracy and legality of any information,
          files, photos, or content you submit through this website. You agree not
          to upload unlawful, harmful, fraudulent, infringing, or malicious
          content.
        </p>
  
        <h2>Intellectual Property</h2>
        <p>
          All website content, branding, graphics, software, text, logos, and
          design elements are the property of the website owner unless otherwise
          stated and may not be copied, reproduced, distributed, or reused without
          written permission.
        </p>
  
        <h2>Third-Party Services</h2>
        <p>
          This website may integrate with or link to third-party services,
          platforms, or websites. We are not responsible for third-party content,
          services, availability, security, or policies.
        </p>
  
        <h2>Disclaimer of Warranties</h2>
        <p>
          This website and all related services are provided “as is” and “as
          available” without warranties of any kind, express or implied, including
          but not limited to warranties of accuracy, reliability, availability,
          merchantability, fitness for a particular purpose, or non-infringement.
        </p>
  
        <h2>Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we shall not be liable for any
          indirect, incidental, consequential, special, punitive, or business
          damages arising from or related to the use of this website, submitted
          information, service interruptions, data loss, or reliance on website
          content.
        </p>
  
        <h2>Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless the website owner, affiliates,
          employees, contractors, and representatives from claims, liabilities,
          damages, losses, or expenses arising from your use of the website or
          violation of these Terms.
        </p>
  
        <h2>Availability and Modifications</h2>
        <p>
          We reserve the right to modify, suspend, restrict, or discontinue any
          portion of the website at any time without notice.
        </p>
  
        <h2>Privacy</h2>
        <p>
          Your use of this website is also governed by our Privacy Policy.
        </p>
  
        <h2>Governing Law</h2>
        <p>
          These Terms shall be governed by and interpreted under the laws of the
          applicable jurisdiction without regard to conflict of law principles.
        </p>
  
        <h2>Changes to These Terms</h2>
        <p>
          We may update these Terms of Use at any time. Continued use of the
          website after changes are posted constitutes acceptance of the updated
          Terms.
        </p>
  
        <h2>Contact Information</h2>
        <p>
          If you have questions regarding these Terms of Use, please contact:
        </p>
  
        <p>
          <strong>Griffin Managed Web Solutions</strong>
          <br />
          info@griffinmanagedwebsolutions.com
          <br />
          +1 (346) 800-2659
        </p>
      </main>
    );
  };
  
  export default TermsOfUse;
